const namespaced = true;

export const getters = {
  readableValue: state => {
    if (!state.value) {
      return '';
    }

    const selectedValues = state.value.split(',').map(value => parseInt(value, 10));
    const selectedOptions = state.options.filter(option => selectedValues.includes(option.id));

    return selectedOptions.map(option => option.name).join(', ');
  },
};

export const mutations = {
  SET_VALUE(state, value) {
    state.value = value;
  },

  SET_OPTIONS(state, options = []) {
    state.options = options;
    state.value = '';
  },

  RESET(state) {
    state.value = '';
  },
};

const state = {
  key: 'feature_groups',
  name: 'Group',
  options: [],
  value: '',
};

export default {
  namespaced,
  state,
  getters,
  mutations,
};
